import { useContext } from 'react';
import { VALID_HEADING_TYPES, VALID_HEADING_SIZES, HeadingContext } from './context.es.js';

/**
 * Heading context hook.
 * @throws
 */ const useHeadingContext = ()=>{
    const context = useContext(HeadingContext);
    if (!context) {
        throw new Error('No context available.');
    }
    return context;
};
/**
 * Allowed sizes type guard.
 */ function isValidHeadingSize(size) {
    return VALID_HEADING_SIZES.includes(size);
}
/**
 * Allowed types type guard.
 */ function isValidHeadingType(type) {
    return VALID_HEADING_TYPES.includes(type);
}

export { isValidHeadingSize, isValidHeadingType, useHeadingContext };
//# sourceMappingURL=index.es.js.map
